import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpward = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M450-160v-526L202-438l-42-42 320-320 320 320-42 42-248-248v526h-60Z" })
});
export default SvgArrowUpward;
